import { ASK_USER_QUESTION_TOOL_NAME } from './constants';

export const ASK_USER_QUESTION_DESCRIPTION = `当你在执行过程中需要向用户提问时，使用此工具。它可以让你:
1. 收集用户偏好或需求
2. 澄清含糊不清的指令
3. 在工作过程中获取关于实现选择的决策
4. 向用户提供可选择的方向

使用说明：
- 用户始终可以选择“其他”来输入自定义文本
- 使用 multiSelect: true 允许用户为一个问题选择多个答案
- 如果你推荐某个具体选项，请将它放在选项列表的第一位，并在标签末尾添加"（推荐）"
- 一个问题最多有4个选项, 如果超出会引发确定的错误

# JSON 参数格式要求：
  - 调用 AskUserQuestion 时，所有 JSON 字符串值必须是合法 JSON
  - 在 question、header、label、description、preview 中不要直接使用 ASCII 双引号"
  - 如需引用术语、文件名、命令、字段名，请使用中文引号「」或单引号 '，例如「strict mode」或 'strict mode'
  - 不要在 preview 中放包含大量引号的代码片段；需要展示代码时，用简短自然语言描述差异
  - 如果确实必须在字符串值中使用 ASCII 双引号，必须写成 \\"，但优先避免使用`;

export function formatAskUserQuestionResult(args: {
  answers?: Record<string, string> | null;
  annotations?: Record<
    string,
    { preview?: string | null; notes?: string | null }
  > | null;
}): string {
  const answers = args.answers ?? {};
  const entries = Object.entries(answers);
  if (entries.length === 0) {
    return `用户未提供 ${ASK_USER_QUESTION_TOOL_NAME} 的答案. 仅当剩余上下文足够时继续；否则请提出更清晰的问题`;
  }

  const answersText = entries
    .map(([questionText, answer]) => {
      const annotation = args.annotations?.[questionText];
      const parts = [`"${questionText}"="${answer}"`];
      if (annotation?.preview) {
        parts.push(`selected preview:\n${annotation.preview}`);
      }
      if (annotation?.notes) {
        parts.push(`user notes: ${annotation.notes}`);
      }
      return parts.join(' ');
    })
    .join(', ');

  return `${answersText} <system-reminder>用户已经回答了你的问题。现在你可以结合用户的回答继续进行</system-reminder>`;
}
